module.exports = __webpack_public_path__ + "static/media/img_selfie.aede64c8.svg";